export default __webpack_public_path__ + "static/MateuszCzajkowski-27cb369dd5128b9320dab455ae06f996.png";